import People from 'actions/people';

export default People.createReducer();
